import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
  withCredentials: true 
});

export function post(path, data, config = {}) {
  return apiClient.post(path, data, config);
}
export const get = (url, config = {}) => {
  return apiClient.get(url, config);
};